import Header from "../component/Header";
import { useState ,useRef} from "react";
import { Box ,Tabs,Tab, Typography, TextField,FormControl, IconButton, InputAdornment, Button, Dialog, DialogTitle, DialogContentText, DialogActions, InputLabel, Select, MenuItem} from "@mui/material";
import { ResetTvRounded, Visibility, VisibilityOff } from "@mui/icons-material";
import { authSignin ,authSignout, authSignup} from "../services/api/api";
import { useCookies } from "react-cookie";
import { cookieMaxAge } from "../constants/constants";
import AlertsSnackbar from "../component/AlertsSnackbar";
import TermsTypography from "../component/TermsTypography";
import PrivacyPolicyTypography from "../component/PrivacyPolicyTypography";
import { useNavigate } from "react-router-dom";
import MyBottomNavigation from "../component/MyBottomNavigation";
import { useTranslation } from "react-i18next";

interface TabPanelProps {
  children?:React.ReactNode
  index:number
  value:number
  setOpenSnackbar:React.Dispatch<React.SetStateAction<boolean>>
  setAlertsMessage:React.Dispatch<React.SetStateAction<string>>
  setSeverity:React.Dispatch<React.SetStateAction<"error" | "success">>
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, setOpenSnackbar, setAlertsMessage , setSeverity, ...other } = props;
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(['recotech_mapapps_token']);
  const { t } = useTranslation();

  const [userName, setUserName] = useState<string>("");
  const [mail, setMail] = useState<string>("");
  const inputMailRef = useRef<HTMLInputElement>(null);
  const [inputMailError, setInputMailError] = useState<boolean>(false);

  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [password, setPassword] = useState<string>("");
  const inputPasswordRef = useRef<HTMLInputElement>(null);
  const [inputPasswordError, setInputPasswordError] = useState<boolean>(false);
  const [password_confirmation, setPassword_confirmation] = useState<string>("");

  const [age,setAge] = useState<string>("");
  const [gender,setGender] = useState<string>("");
  const [country,setCountry] = useState<number | null>(null);
  
  const [openTerms, setOpenTerms] = useState(false);
  const [openPrivacyPolicy, setOpenPrivacyPolicy] = useState(false);
  const [isCheckedTerms, setIsCheckedTerms] = useState(false);
  const [isCheckedPrivacyPolicy, setIsCheckedPrivacyPolicy] = useState(false);

  const [zipCode, setZipCode] = useState<string>("");
  const inputZipCodeRef = useRef<HTMLInputElement>(null);
  const [inputZipCodeError, setInputZipCodeError] = useState<boolean>(false);

  const [isWaitingResponse, setIsWaitingResponse] = useState<boolean>(false);

  const handleZipCodeChange = (value:React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    // 郵便番号のバリデーションを無効化
    setInputZipCodeError(false);
    setZipCode(value.target.value)
  };

  const handleMailChange = (value:React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (inputMailRef.current) {
      const ref = inputMailRef.current;
      if (!ref.validity.valid) {
        setInputMailError(true);
      } else {
        setInputMailError(false);
      }
    }
    setMail(value.target.value)
  };

  const handlePasswordChange = (value:React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (inputPasswordRef.current) {
      const ref = inputPasswordRef.current;
      if (!ref.validity.valid) {
        setInputPasswordError(true);
      } else {
        setInputPasswordError(false);
      }
    }
    setPassword(value.target.value)
  };

  function handleClickShowPassword() {
    setShowPassword(!(showPassword))
  }

  function handleMouseDownPassword(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
  };

  return (
    <>
      <Dialog
        open={openTerms}
        onClose={()=>setOpenTerms(false)}
        scroll={"body"}
      >
        <DialogTitle id="scroll-dialog-title">{t("pages.login.termsConsent")}</DialogTitle>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}
          >
            <Box
              sx={{ p: 3 }}
              display="flex"
              alignItems="start"
              justifyContent="start"
              flexDirection="column"
            >
              <TermsTypography/>
            </Box>
          </DialogContentText>
        <DialogActions>
          <Button onClick={()=>{
            setOpenTerms(false)
          }}>{t("pages.login.cancel")}</Button>
          <Button onClick={()=>{
            setIsCheckedTerms(true)
            setOpenTerms(false)
          }}>{t("pages.login.agree")}</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPrivacyPolicy}
        onClose={()=>setOpenPrivacyPolicy(false)}
        scroll={"body"}
      >
        <DialogTitle id="scroll-dialog-title">{t("pages.login.privacyConsent")}</DialogTitle>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}
          >
            <Box
              sx={{ p: 3 }}
              display="flex"
              alignItems="start"
              justifyContent="start"
              flexDirection="column"
            >
              <PrivacyPolicyTypography/>
            </Box>
          </DialogContentText>
        <DialogActions>
          <Button onClick={()=>{
            setOpenPrivacyPolicy(false)
          }}>{t("pages.login.cancel")}</Button>
          <Button onClick={()=>{
            setIsCheckedPrivacyPolicy(true)
            setOpenPrivacyPolicy(false)
          }}>{t("pages.login.agree")}</Button>
        </DialogActions>
      </Dialog>
          
      <Box
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box 
            sx={{ p: 3 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <FormControl>
              <TextField
                style={{width: "90vw", marginTop: "10px"}}
                id="outlined-basic-1"
                label={t("pages.login.email")}
                variant="outlined"
                fullWidth={true}
                value={mail}
                helperText={
                  inputMailError ? t("pages.login.emailFormat") : null
                }
                type={'mail'}
                inputProps={{
                  pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
                }}
                onChange={(value)=>{
                  handleMailChange(value)
                }}  
                error={inputMailError}
                inputRef={inputMailRef}
                defaultValue=""
              />
            </FormControl>
            {(value === 1)?
            <FormControl sx={{mt:2}}>
              <TextField
                style={{width: "90vw", marginTop: "10px"}}
                id="outlined-basic-0"
                label={t("pages.login.name")}
                variant="outlined"
                fullWidth={true}
                value={userName}
                type={'useName'}
                onChange={(value)=>{
                  setUserName(value.target.value)
                }}  
                defaultValue=""
              />
            </FormControl>
            :<></>
            }
            {(value === 1)?
            <Box
            justifyContent={"space-between"}
            alignItems={"center"}
            display={"flex"}
            flexDirection={"row"}
            style={{width: "90vw", marginTop: "10px"}}
            >
              <FormControl style={{width: "22%"}}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  displayEmpty
                  onChange={(value)=>{
                    setAge(value.target.value)
                  }}
                >
                  <MenuItem disabled value="">{t("pages.login.age")}</MenuItem>  
                  <MenuItem value={"10"}>{t("pages.login.age10")}</MenuItem>
                  <MenuItem value={"20"}>{t("pages.login.age20")}</MenuItem>
                  <MenuItem value={"30"}>{t("pages.login.age30")}</MenuItem>
                  <MenuItem value={"40"}>{t("pages.login.age40")}</MenuItem>
                  <MenuItem value={"50"}>{t("pages.login.age50")}</MenuItem>
                  <MenuItem value={"60"}>{t("pages.login.age60")}</MenuItem>
                  <MenuItem value={"70"}>{t("pages.login.age70")}</MenuItem>
                  <MenuItem value={"80"}>{t("pages.login.age80")}</MenuItem>
                  <MenuItem value={"90"}>{t("pages.login.age90")}</MenuItem>
                  <MenuItem value={"100"}>{t("pages.login.age100")}</MenuItem>
                </Select>
              </FormControl>
              <FormControl style={{width: "22%"}}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={gender}
                  displayEmpty
                  onChange={(value)=>{
                    setGender(value.target.value)
                  }}
                >
                  <MenuItem disabled value="">{t("pages.login.gender")}</MenuItem>  
                  <MenuItem value={"man"}>{t("pages.login.male")}</MenuItem>
                  <MenuItem value={"woman"}>{t("pages.login.female")}</MenuItem>
                  <MenuItem value={"other"}>{t("pages.login.other")}</MenuItem>
                </Select>
              </FormControl>
              <FormControl style={{width: "22%"}}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={country ?? ""}
                  displayEmpty
                  onChange={(value)=>{
                    setCountry(value.target.value === "" ? null : Number(value.target.value))
                  }}
                >
                  <MenuItem disabled value="">{t("pages.login.country")}</MenuItem>  
                  <MenuItem value={1}>{t("pages.login.japan")}</MenuItem>
                  <MenuItem value={2}>{t("pages.login.malaysia")}</MenuItem>
                </Select>
              </FormControl>
              <FormControl style={{width: "27%"}}>
                <TextField
                  label={t("pages.login.zipCode")}
                  variant="outlined"            
                  fullWidth={true}
                  type={'text'}
                  value={zipCode}
                  onChange={(value)=>{
                    handleZipCodeChange(value)
                  }}  
                  helperText={
                    inputZipCodeError ? t("pages.login.zipCodeInstruction") : null
                  }
                  inputProps={{
                    inputMode: "numeric", // モバイルデバイス用に数字入力モードを指定する
                    // pattern: "\\d{7}", // バリデーションを無効化
                    maxLength: 7, // 最大7桁の制限はそのまま残す
                  }}
                  error={inputZipCodeError}
                  inputRef={inputZipCodeRef}
                />
              </FormControl>
            </Box>
            :
            <></>
            }
            <FormControl>
              <TextField
                style={{width: "90vw", marginTop: "30px"}}
                id="outlined-basic-2"
                label={t("pages.login.password")}
                variant="outlined"            
                fullWidth
                value={password}
                helperText={t("pages.login.passwordInstruction")}
                type={showPassword ? 'text' : 'password'}
                inputProps={{
                  minLength: 6,
                  pattern: "^[a-zA-Z0-9!-/:-@¥[-`{-~]+$",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                onChange={(value)=>{
                  handlePasswordChange(value)
                }}  
                error={inputPasswordError}
                inputRef={inputPasswordRef}
                defaultValue=""
              />
            </FormControl>
            {(value === 1)?
            <>
              <FormControl>
              <TextField
                style={{width: "90vw", marginTop: "30px"}}
                id="outlined-basic-3"
                label={t("pages.login.passwordConfirm")}
                variant="outlined"            
                fullWidth
                value={password_confirmation}
                helperText={t("pages.login.passwordConfirmInstruction")}
                type={showPassword ? 'text' : 'password'}
                inputProps={{
                  minLength: 6,
                  pattern: "^[a-zA-Z0-9_]+$",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                onChange={(value)=>{
                  setPassword_confirmation(value.target.value)
                }}  
                defaultValue=""
              />
            </FormControl>
            <Box marginTop={2}>
              <Button
                disabled={isCheckedTerms}
                onClick={()=>setOpenTerms(true)}
              >
                {isCheckedTerms ? t("pages.login.termsAgreed") : t("pages.login.termsAgree")}
              </Button>
              <Button
                disabled={isCheckedPrivacyPolicy}
                onClick={()=>setOpenPrivacyPolicy(true)}
              >
                {isCheckedPrivacyPolicy ? t("pages.login.privacyAgreed") : t("pages.login.privacyAgree")}
              </Button>
            </Box>
            </>
            :
            <>
              <Box marginTop={2}>
                <Button
                    target="_blank"
                    href={`${process.env.REACT_APP_BACKEND_URL!}/user/password_reset/new`}
                >
                  {t("pages.login.forgotPassword")}
                </Button>
              </Box>
            </>}
            <Button
              disabled={inputMailError || inputPasswordError || mail === "" || password === "" || isWaitingResponse}
              variant="contained"
              style={{width: "90vw", marginTop: "30px" ,backgroundColor: (inputMailError || inputPasswordError || mail === "" || password === "" || isWaitingResponse)?"#C0C0C0":"#4B4B4B", color: "white",borderRadius: "20px"}}
              onClick={async ()=>{
                if(value === 0){
                  const res = await authSignin(mail,password,setAlertsMessage,setSeverity,setOpenSnackbar)
                  if(res){
                    //ログイン後の処理
                    setCookie("recotech_mapapps_token", res, { maxAge: cookieMaxAge ,sameSite:"lax" ,secure:true})
                    navigate("/")
                  }else{
                    //ログイン失敗の処理
                  }  
                }else if(value === 1){
                  if(age === ""){
                    setAlertsMessage(t("pages.login.ageRequired"))
                    setSeverity("error")
                    setOpenSnackbar(true)
                    return
                  }
                  if(gender === ""){
                    setAlertsMessage(t("pages.login.genderRequired"))
                    setSeverity("error")
                    setOpenSnackbar(true)
                    return
                  }
                  if(country === null){
                    setAlertsMessage(t("pages.login.countryRequired"))
                    setSeverity("error")
                    setOpenSnackbar(true)
                    return
                  }
                  if(inputZipCodeError || zipCode === ""){
                    // 郵便番号の入力フォーマットのチェックを無効化 (空欄チェックのみ残す)
                    if(zipCode === "") {
                      setAlertsMessage(t("pages.login.zipCodeInvalid"))
                      setSeverity("error")
                      setOpenSnackbar(true)
                      return
                    }
                  }
                  let address = ""
                  let lat = 0
                  let lng = 0
                  try {
                    if(google){
                      const geocoder = new google.maps.Geocoder();
                      let geocodeRequest: google.maps.GeocoderRequest = { address: zipCode, region: "jp" }; // デフォルトは日本

                      if (country === 2) { // マレーシアが選択された場合
                        geocodeRequest = {
                          componentRestrictions: {
                            postalCode: zipCode,
                            country: "MY",
                          },
                        };
                      }
                      const response = await geocoder.geocode(geocodeRequest);

                      const location = response?.results?.[0]?.geometry?.location;
                      if (location && typeof location.lat === 'function' && typeof location.lng === 'function') {
                        const Rlat = location.lat();
                        const Rlng = location.lng();

                        if (Rlat === 0 && Rlng === 0) {
                           setAlertsMessage(t("pages.login.geocodeFailedDetail", { details: "Invalid coordinates (0,0)" })); // 仮の翻訳キー
                           setSeverity("error");
                           setOpenSnackbar(true);
                           return;
                        }
                        
                        lat = Rlat;
                        lng = Rlng;

                        const formatted_address_components = response?.results?.[0]?.address_components.reverse().slice(1,-1)
                        formatted_address_components.forEach((address_component) => {
                          address += address_component.long_name
                        })
                      } else {
                        setAlertsMessage(t("pages.login.geocodeFailed")); // 仮の翻訳キー
                        setSeverity("error");
                        setOpenSnackbar(true);
                        return;
                      }
                    }
                  } catch (error: any) {
                    if(error.code === "ZERO_RESULTS"){
                      setAlertsMessage(t("pages.login.zipCodeNotExist"))
                      setSeverity("error")
                      setOpenSnackbar(true)
                      return
                    }else{
                      setAlertsMessage(t("pages.login.error"));
                      setSeverity("error")
                      setOpenSnackbar(true)
                      return
                    }
                  }

                  // 緯度経度が取得できなかった場合 (APIエラー以外も含む)
                  if (lat === 0 || lng === 0) {
                    // このチェックは上記if/else内で吸収されるか、より具体的なメッセージになっているはずなので、
                    // ここでは重複を避けるか、非常に汎用的なフォールバックとする。
                    // ただし、上のロジックで return されているはずなので、基本的にはここには到達しない想定。
                    // setAlertsMessage(t("pages.login.geocodeFailedGeneral")); // 非常に汎用的なエラー
                    // setSeverity("error");
                    // setOpenSnackbar(true);
                    // return;
                  }

                  if(password !== password_confirmation){
                    setAlertsMessage(t("pages.login.passwordMismatch"))
                    setSeverity("error")
                    setOpenSnackbar(true)
                    return
                  }
                  if(isCheckedTerms === false){
                    setAlertsMessage(t("pages.login.termsRequired"))
                    setSeverity("error")
                    setOpenSnackbar(true)
                    return
                  }
                  if(isCheckedPrivacyPolicy === false){
                    setAlertsMessage(t("pages.login.privacyRequired"))
                    setSeverity("error")
                    setOpenSnackbar(true)
                    return
                  }
                  const res = await authSignup(userName,mail,gender,age,country,zipCode,address,lat,lng,password,password_confirmation,setAlertsMessage,setSeverity,setOpenSnackbar,setIsWaitingResponse)
                  if(res){
                    //新規登録後の処理
                    setCookie("recotech_mapapps_token", res, { maxAge: cookieMaxAge ,sameSite:"lax" ,secure:true})
                    navigate("/")
                  }else{
                    //新規登録失敗の処理
                  }  
                }                  
              }}
            >
              {children}
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
function Login(): JSX.Element {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies(['recotech_mapapps_token']);
  const { t } = useTranslation();
  
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  //SnackBarの設定
  const [openSnackbar, setOpenSnackbar] = useState<boolean>(false);
  const [alertsMessage, setAlertsMessage] = useState<string>("");
  const [severity, setSeverity] = useState< "error" | "success" >("error");
    return (
      <>
        <AlertsSnackbar
          openSnackbar={openSnackbar}
          setOpenSnackbar={setOpenSnackbar}
          vertical={"bottom"}
          severity={severity}
          message={alertsMessage}
        />
        <Header/>
        {(cookies.recotech_mapapps_token)?
        <Box
          sx={{ p: 3 }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
        >
          <Typography component="div" variant="caption">
            {t("pages.login.confirmLogout")}
          </Typography>
            <Button
              variant="contained"
              style={{width: "90vw", marginTop: "30px" ,backgroundColor:"#4B4B4B", color: "white",borderRadius: "20px"}}
              onClick={async ()=>{
                const res = await authSignout(cookies.recotech_mapapps_token,setAlertsMessage,setSeverity,setOpenSnackbar)
                if(res){
                  //ログアウト後の処理
                  removeCookie("recotech_mapapps_token")
                  navigate("/")
                }else{
                  //ログアウト失敗の処理
                }  
              }}
            >
              {t("pages.login.logout")}
            </Button>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              width="100%"
              sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
              }}
            >
              <MyBottomNavigation />
            </Box>
        </Box>
        :<>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
              <Tab sx={{ minWidth: '50%' }} label={t("pages.login.login")} {...a11yProps(0)} />
              <Tab sx={{ minWidth: '50%' }} label={t("pages.login.register")} {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={tabValue} index={0} setOpenSnackbar={setOpenSnackbar} setAlertsMessage={setAlertsMessage} setSeverity={setSeverity}>
            {t("pages.login.login")}
          </TabPanel>
          <TabPanel value={tabValue} index={1} setOpenSnackbar={setOpenSnackbar} setAlertsMessage={setAlertsMessage} setSeverity={setSeverity}>
            {t("pages.login.register")}
          </TabPanel>
        </Box>
        </>}
      </>
    );
};
export default Login;
